import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "page-container" };
import { ref, computed, provide, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import DesktopSidebar from './components/DesktopSidebar.vue';
import { useAuth } from '../composables/useAuth';
import { useAppState } from '../composables/useAppState';
import { useCustomer } from '../composables/useCustomer';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Desktop',
    setup(__props) {
        useAuth();
        const router = useRouter();
        const route = useRoute();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const state = useAppState();
        const customerApi = useCustomer();
        const colourMode = ref('dark');
        const userName = ref('User');
        const sidebarOpen = ref(false);
        const sidebarCollapsed = ref(false);
        const sidebarConfig = ref({});
        const sidebarData = ref({});
        const sidebarHandlers = ref({});
        const sidebarPageItems = ref([]);
        const defaultNavItems = ref([
            //	{ icon: 'mdi-wallet-outline', label: 'Money', route: '/desktop/money' },
            { icon: 'mdi-format-list-bulleted', label: 'Money', route: '/desktop/money' },
            { icon: 'mdi-chart-pie', label: 'Analysis', route: '/desktop/analysis' },
            //	{ icon: 'mdi-ticket-percent-outline', label: 'Vouchers', route: '/desktop/shopvouchers' },
            { icon: 'mdi-chat-outline', label: 'Chat', route: '/desktop/chat' }
        ]);
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? 0);
        });
        provide('registerSidebar', (config) => {
            sidebarConfig.value = config.config || {};
            sidebarData.value = config.data || {};
            sidebarHandlers.value = config.handlers || {};
            // Reset page items when a new page registers
            sidebarPageItems.value = [];
            if (config.config?.pageItems && config.config.pageItems.length > 0) {
                sidebarPageItems.value = [...config.config.pageItems];
            }
        });
        provide('updateSidebarPageItems', (items) => {
            sidebarPageItems.value = [...items];
        });
        function handleLogout() {
            cookies?.remove('token');
            router.push({ path: '/login', query: { landingpage: route.path } });
        }
        function handleActionClick() {
            sidebarHandlers.value?.onActionClick?.();
            sidebarOpen.value = false;
        }
        function handlePageItemClick(id) {
            sidebarHandlers.value?.onPageItemClick?.(id);
            sidebarOpen.value = false;
        }
        function handlePageItemDelete(id) {
            sidebarHandlers.value?.onPageItemDelete?.(id);
        }
        function handlePageItemRename(data) {
            sidebarHandlers.value?.onPageItemRename?.(data);
        }
        function handleOpenSettings() {
            sidebarHandlers.value?.onOpenSettings?.();
            sidebarOpen.value = false;
        }
        function toggleSidebarCollapse() {
            sidebarCollapsed.value = !sidebarCollapsed.value;
            localStorage.setItem('mg_sidebar_collapsed', String(sidebarCollapsed.value));
        }
        onMounted(() => {
            const savedMode = localStorage.getItem('mg_colour_mode');
            if (savedMode) {
                colourMode.value = savedMode;
            }
            else {
                colourMode.value = 'light';
                localStorage.setItem('mg_colour_mode', 'light');
            }
            const savedCollapsed = localStorage.getItem('mg_sidebar_collapsed');
            if (savedCollapsed === 'true') {
                sidebarCollapsed.value = true;
            }
            customerApi.getCustomer(() => {
                if (state.customer?.person?.firstName) {
                    userName.value = state.customer.person.firstName;
                }
            });
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["desktop-layout", [colourMode.value, { 'sidebar-collapsed': sidebarCollapsed.value }]])
            }, [
                _createElementVNode("div", {
                    class: "desktop-content",
                    style: _normalizeStyle({ top: safeTop.value + 'px' })
                }, [
                    _createElementVNode("button", {
                        class: "menu-toggle",
                        onClick: _cache[0] || (_cache[0] = ($event) => (sidebarOpen.value = !sidebarOpen.value))
                    }, [
                        _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-menu")
                            ])),
                            _: 1
                        })
                    ]),
                    _createVNode(DesktopSidebar, {
                        open: sidebarOpen.value,
                        collapsed: sidebarCollapsed.value,
                        colourMode: colourMode.value,
                        safeTop: safeTop.value,
                        navItems: sidebarConfig.value.navItems || defaultNavItems.value,
                        pageItems: sidebarPageItems.value.length ? sidebarPageItems.value : (sidebarData.value.recentChats || []),
                        pageItemsTitle: sidebarConfig.value.pageItemsTitle,
                        pageItemsEmptyText: sidebarConfig.value.pageItemsEmptyText,
                        currentPageItemId: sidebarConfig.value.currentPageItemId || sidebarData.value.currentChatId,
                        actionButton: sidebarConfig.value.actionButton,
                        userName: sidebarData.value.userName || userName.value,
                        onClose: _cache[1] || (_cache[1] = ($event) => (sidebarOpen.value = false)),
                        onLogout: handleLogout,
                        onActionClick: handleActionClick,
                        onPageItemClick: handlePageItemClick,
                        onPageItemDelete: handlePageItemDelete,
                        onPageItemRename: handlePageItemRename,
                        onOpenSettings: handleOpenSettings,
                        onToggleCollapse: toggleSidebarCollapse
                    }, null, 8, ["open", "collapsed", "colourMode", "safeTop", "navItems", "pageItems", "pageItemsTitle", "pageItemsEmptyText", "currentPageItemId", "actionButton", "userName"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_router_view, {
                            onColourModeChanged: _cache[2] || (_cache[2] = ($event) => (colourMode.value = $event))
                        })
                    ])
                ], 4)
            ], 2));
        };
    }
});
